import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {FormControl} from '@angular/forms';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';

@Component({
  selector: 'app-subject-expert',
  templateUrl: './subject-expert.component.html',
  styleUrls: ['./subject-expert.component.css']
})
export class SubjectExpertComponent implements OnInit {
	@HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
	localStorage.removeItem('access_token');
	localStorage.removeItem('navigateroute');
  }
	list=true;
  	edit=false;
  	add=false;
  	addSubject=false;
  	icon=this.helper.add_icon;
	icon_action='addClick';
	datas:any=[];
	teacherSubjectList:any=[];
	dtOptions: DataTables.Settings = {};
	dtTrigger: Subject<any> = new Subject();
	dtElement: DataTableDirective;
	searchTeacher;
	searchTerm;
	syllabus_list:any=[];
  	grade_list:any=[];
  	subject_list:any=[];
  	selected_grade_id:any=[];
  	selected_syllabus_id:any=[];
  	selected_subject_id:any=[];
	subject_count = 1;

	list_show=true;
	edit_show=false;

	teacher_id;
	teacher_name;
	user_permissions:any=[];
	selected_subject_array=[
                    { selected_grade_id:"",selected_syllabus_id:"",selected_subject_id:''}
                   ];
				   user_token= localStorage.getItem('access_token');
				   private headers: Headers = new Headers({
				   'Accept': 'application/json',
				   'Authorization': "Bearer "+this.user_token
				 });
  	constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) 
  	{

  	}

	ngOnInit() 
	{
		let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
		this.dtOptions = {
	      	pagingType: 'full_numbers',
	      	pageLength: 10,
	        order:[]
	    };
	    
	    this.http.get(this.helper.base_url+'http/get/subjectExpertsList',{ headers: this.headers })
	      
	  	.subscribe(data => {
	    	this.datas = JSON.parse(data['_body']);
	      	this.dtTrigger.next();
	  	});
	}

	addClick()
	{
		this.list=false;
	    this.edit=false;
	    this.addSubject=false;
	    this.add=true;
	    this.icon=this.helper.list_icon;
	    
	    this.icon_action="listClick";
	    this.list_show=false;
      	this.edit_show=true;
	}
	listClick()
	{
		this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
		this.router.navigate(["experts_subject"]));
	}

	searchName(name)
  	{
  
	  	if(name != '')
	  	{
	    	this.http.get(this.helper.base_url+'http/get/getTeacherByName?teacher=' + name,{ headers: this.headers }).subscribe(data => {
	        	this.searchTeacher = JSON.parse(data['_body']);
	      	});
	    }
  	}

  	syllabusChange(event:any)
  	{
    	let syllabus_id=event;
    	this.subject_list=[];
   
    	this.grade_list=[];
    
    	this.http.get(this.helper.base_url+'http/get/grade/'+syllabus_id,{ headers: this.headers })
      	.map(this.extractData)
      	.subscribe(data => {
        	this.grade_list = data;
      	});
  	}
  
  	gradeChange(event:any)
  	{
    	let sgid=event.target[event.target.selectedIndex].dataset.sgid;
    
    	this.subject_list=[];
   
    	this.http.get(this.helper.base_url+'http/get/subjects/'+sgid,{ headers: this.headers })
    	.map(this.extractData)
		.subscribe(data => {
      		this.subject_list = data['subject_grade'];
    	});

  	}

  	counter(i: number) {
	    return new Array(i);
	}

	private extractData(res: Response) {
	    const body = res.json();
	    return body.data || {};
	}

	addRow(index)
	{
		this.subject_count++;
		var name = {selected_grade_id:"",selected_syllabus_id:"",selected_subject_id:''};
       	//this.selected_subject_array.push(name);

       	if(this.selected_subject_array.length <= index+1)
            this.selected_subject_array.splice(index+1,0,name);

	}

	deleteRow = function($event,name)
	{
        var index = this.selected_subject_array.indexOf(name);
        if($event.which == 1)
           	this.selected_subject_array.splice(index,1);
    }

   	teacherSelect(item)
   	{
   		this.teacher_id = item.id;
   		this.teacher_name = item.name;
   	}

   	addTeacherSubject()
   	{
      if(this.teacher_id)
      {
        this.list=false;
        this.edit=false;
        this.addSubject=true;
        this.add=false;

        this.http.get(this.helper.base_url+'http/get/syllabus',{ headers: this.headers })
        .map(this.extractData)
        .subscribe(syllabuses => {
            this.syllabus_list = syllabuses;
        });

        this.http.get(this.helper.base_url+'http/get/teacherSubjects/' + this.teacher_id,{ headers: this.headers }).subscribe(data => {
            this.teacherSubjectList = JSON.parse(data['_body']);
          });

          this.icon_action="listClick";
          this.list_show=false;
          this.edit_show=true;
      }
      else
      {
        this.snackbar.open('User not selected', null, 
        {
          duration:5000,
          extraClasses:'error-snackbar',
          verticalPosition:'top'
        });
      }
   		
   	}

   	saveSubject()
   	{
   		let body = new FormData();
  		body.append('teacher_id', this.teacher_id);
  		body.append('syllubus_id', this.selected_syllabus_id);
  		body.append('grade_id', this.selected_grade_id);
  		body.append('subject_id', this.selected_subject_id);
   		
		  this.http.post(this.helper.base_url+'http/add/saveTeacherSubject', body,{ headers: this.headers })
   			.subscribe((data) => 
   			{
          let result = JSON.parse(data['_body']);

          if(result.status == 'success')
          {
            this.teacherSubjectList = JSON.parse(data['_body']).teachers;

            this.selected_syllabus_id = '';
            this.selected_grade_id = '';
            this.selected_subject_id = '';

            this.snackbar.open('Subject added successfully', null, 
            {
              duration:5000,
              extraClasses:'success-snackbar',
              verticalPosition:'top'
            });
          }
          else
          {
            this.snackbar.open('Subject already allocated', null, 
            {
              duration:5000,
              extraClasses:'error-snackbar',
              verticalPosition:'top'
            });
          }
   				
 			}, //For Success Response
  			err => {console.error(err)} //For Error Response);
		);
   	}

   	editClick(id)
   	{
   		this.list=false;
	    this.edit=true;
	    this.addSubject=false;
	    this.add=false;

	    this.http.get(this.helper.base_url+'http/get/teacherSubjects/' + id,{ headers: this.headers }).subscribe(data => {
        	this.teacherSubjectList = JSON.parse(data['_body']);
        	this.teacher_id = JSON.parse(data['_body'])[0].user_details.id;
   			this.teacher_name = JSON.parse(data['_body'])[0].user_details.email;
      	});

      	this.icon=this.helper.list_icon;

      	this.list_show=false;
      	this.edit_show=true;
   	}

   	deleteClick(id)
   	{
		let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
			duration: 3000,
        extraClasses:  ['warning-snackbar'],
      }).onAction().subscribe(() => {
   		this.http.get(this.helper.base_url+'http/delete/teacherSubject/'+id,{ headers: this.headers })
	    .subscribe(data => {
	        this.snackbar.open('Subject deleted successfully', null, 
	  		{
	    		duration:5000,
	      		extraClasses:'success-snackbar',
	      		verticalPosition:'top'
	   	 	});
	        this.editClick(this.teacher_id);
		});
	});
   	}


}



// WEBPACK FOOTER //
// ./src/app/subject-expert/subject-expert.component.ts